import { FC } from 'react';

import { Box } from '@mui/material';
import Button from '@mui/material/Button';

interface Props {
  videoId: string;
}

export const ResultButton: FC<Props> = ({ videoId }) => {
  const handleClick = () => {
    window.open(`${window.location.origin}/editor/${videoId}`, '_blank');
  };

  return (
    <Box sx={{ mt: 5 }}>
      <Button variant="contained" onClick={handleClick}>
        Open result
      </Button>
    </Box>
  );
};
